import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
// Angular
import {
  FormBuilder,
  FormGroup,
  NgbModal,
  NgbNav,

  Router,

  Validators,
} from 'src/app/common/angular.index';
// Models
import {
  ALERTS,
  ReportParameter2,
  Report,
  Report2,
  REPORT_PARAMETER,
  ParameterOption,
  ReportUser,
  ReportParameter,
} from 'src/app/common/models.index';
// Services
import {
  AlertService,
  BlockUIHandlerService,
  CommonService,
  CompanyService,
  RptManagerService,
  SideBarService,
} from 'src/app/common/services.index';
import { debounceTime, distinctUntilChanged, finalize, first, map, merge, timestamp } from 'rxjs/operators';
import { AppConstants, IApplication, ICompany, IMenuOption, IParameterDataSource } from 'src/app/models';
import { NgbModalRef, NgbNavChangeEvent, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Observable, Subscription } from 'rxjs';
import { StorageService } from 'src/app/services';
import { ActivatedRoute } from '@angular/router';
import { IConnection } from '../../models/i-connection';
import { ConnectionService } from '../../services/connection.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
})
export class ReportsComponent implements OnInit, OnDestroy {
  //VARBOX
  connections: IConnection[];
  reportId: number;
  @ViewChild('nav', { static: true }) nav: NgbNav;

  activeTab: number;
  reportForm: FormGroup;
  parameterForm: FormGroup;
  parameterValueForm: FormGroup;

  reportUsers: ReportUser[];
  parameters: ReportParameter2[];
  reports: Report[];
  report: File;
  parameterOptions: ParameterOption[];
  parameterOptionsModal: ParameterOption[];

  parameterSubgroup1: ReportParameter2[];
  parameterSubgroup2: ReportParameter2[];
  parameterSubgroup3: ReportParameter2[];
  parameterSubgroup4: ReportParameter2[];
  paramaterListGroup: ReportParameter2[][];

  Application: IApplication;
  Company: ICompany;
  Companies: ICompany[];
  modalReference: NgbModalRef;
  @ViewChild('modalContent') modal: ElementRef;
  isRaisedFromEvent: boolean;
  menu: IMenuOption[];
  applications: IApplication[];

  focus$ = new Subject<string>();
  click$ = new Subject<string>();


  @ViewChild('instance', { static: true }) instance: NgbTypeahead;


  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && (!this.Company || !this.Application)) {
      this.GoToHome();
    }
  }
  subsCription: Subscription;


  AppKeyParam: number;
  CompanyKeyParam: number;


  constructor(
    private companyService: CompanyService,
    private router: Router,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService,
    private commonService: CommonService,
    private rptManagerService: RptManagerService,
    private blockUI: BlockUIHandlerService,
    private sidebarService: SideBarService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private connectionService: ConnectionService
  ) {
  }


  ngOnDestroy(): void {

    this.commonService.appOrCompanyHeaderTittle.next({ ObjecName: '', From: 0 });
    if (this.subsCription)
      this.subsCription.unsubscribe();
  }

  ngOnInit(): void {

    this.CompanyKeyParam = +this.route.snapshot.paramMap.get('CompanyKey');
    this.AppKeyParam = +this.route.snapshot.paramMap.get('AppKey');

    // this.nav.activeIdChange.subscribe(() => this.onTabChange());
    this.reportForm = this.formBuilder.group({
      Id: 0,
      Name: ['', Validators.required],
      DisplayName: ['', Validators.required],
      ReportUserId: [0, Validators.required],
      DBCode: [''],
      Server: [''],
      SAPConnection: [-1]
    });

    this.parameterForm = this.formBuilder.group({
      Id: [0],
      ReportId: [0],
      Name: ['', Validators.required],
      DisplayName: ['', Validators.required],
      Type: [1, Validators.required],
      Required: ['S', Validators.required],
      DBObjectName: ['']
    });

    this.parameterValueForm = this.formBuilder.group({
      Key: ['', Validators.required],
      Value: ['', Validators.required],
    });

    this.initializeApp();

    this.GetCompanies();

    this.GetApplications();

    this.getReportUsers();

    this.getReports();

    this.GetConnections();

    setTimeout(_ => this.sidebarService.toggler.next(false));
  }



  initializeApp() {
    this.menu = AppConstants.GetMenu;
    this.isRaisedFromEvent = false;
    this.Companies = [];
    this.applications = [];
    this.parameterSubgroup1 = [];
    this.parameterSubgroup2 = [];
    this.parameterSubgroup3 = [];
    this.parameterSubgroup4 = [];
    this.paramaterListGroup = [];
    this.parameters = [];
    this.paramaterListGroup.push(
      this.parameterSubgroup1,
      this.parameterSubgroup2,
      this.parameterSubgroup3,
      this.parameterSubgroup4
    );
    this.parameterOptions = [];
    this.parameterOptionsModal = [];
    this.activeTab = 1;
    this.report = null;
    this.resetParameterForm();
    this.resetReportForm();
    this.resetParameterValueForm();
  }

  ResetFormsOnClear(): void {
    this.menu = AppConstants.GetMenu;
    this.isRaisedFromEvent = false;
    this.Companies = [];
    this.applications = [];
    this.parameterSubgroup1 = [];
    this.parameterSubgroup2 = [];
    this.parameterSubgroup3 = [];
    this.parameterSubgroup4 = [];
    this.paramaterListGroup = [];
    this.parameters = [];
    this.paramaterListGroup.push(
      this.parameterSubgroup1,
      this.parameterSubgroup2,
      this.parameterSubgroup3,
      this.parameterSubgroup4
    );
    this.parameterOptions = [];
    this.parameterOptionsModal = [];
    this.report = null;
    this.resetParameterForm();
    this.resetReportForm();
    this.resetParameterValueForm();
  }
  resetParameterForm() {
    this.parameterForm.reset({
      Id: 0,
      ReportId: 0,
      DisplayName: '',
      Name: '',
      Type: 1,
      Required: 'S',
      DBObjectName: ''
    });
  }

  resetReportForm() {
    this.reportForm.reset({
      Id: 0,
      Name: '',
      DisplayName: '',
      ConnectionType: 1,
    });
  }

  resetParameterValueForm() {
    this.parameterValueForm.reset({
      Key: '',
      Value: '',
    });
  }

  getReportUsers() {
    this.blockUI.Start(1, `Procesando, espere por favor`);
    this.reportUsers = [];

    this.rptManagerService.GetReportUsers().pipe(finalize(() => this.blockUI.Stop()))
      .subscribe(response => {
        if (response.Result) this.reportUsers = response.ReportUsers.filter(user => user.Active);
        else
          this.alertService.ShowBigCenteredAlert(response.ErrorInfo.Message, ALERTS.error);
      }, err => {
        console.info(err);
        this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
      });
  }

  getReports() {
    this.reports = [];
    this.blockUI.Start(1, `Procesando, espere por favor`);
    this.rptManagerService
      .GetReports(this.CompanyKeyParam, this.AppKeyParam).pipe(finalize(() => this.blockUI.Stop())).subscribe((response) => {
        if (response.Result) {

          this.reports = response.Reports;

          if (this.reports!.length === 0) {
            this.alertService.ShowSmallCornerAlert(`No se encontraron reportes configurados`, ALERTS.info);
          }
        } else {
          this.alertService.ShowBigCenteredAlert(
            response.ErrorInfo.Message,
            ALERTS.error
          );
        }
      },
        (err) => {
          this.blockUI.Stop();
          this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
        }
      );
  }

  HandlePostOrPutReport(report: Report2) {
    this.rptManagerService
      .HandlePostOrPutReport(report)
      .pipe(first())
      .subscribe(
        (response: any) => {
          this.blockUI.Stop();
          if (response.Result) {
            this.alertService.ShowSmallCornerAlert(
              'Procoseso finalizado exitosamente',
              ALERTS.success
            );

            this.initializeApp();
            this.getReports();
          } else {
            this.alertService.ShowBigCenteredAlert(
              response.ErrorInfo.Message,
              ALERTS.error
            );
            this.blockUI.Stop();
          }
        },
        (err) => {
          this.blockUI.Stop();
          this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
        }
      );
  }

  onClickEditReport(report: Report) {
    this.reportForm.reset({
      Id: report.Id,
      Name: report.Name,
      DisplayName: report.DisplayName,
      ReportUserId: report.ReportUserId,
      DBCode: report.DBCode,
      SAPConnection: report.SAPConnection
    });


    this.blockUI.Start(1, `Procesando, espere por favor`);
    this.rptManagerService
      .GetParameters(report.Id)
      .pipe(finalize(() => this.blockUI.Stop()))
      .subscribe(
        (response) => {
          if (response.Result) {
            this.activeTab = 2;
            if (response.Parameters && response.Parameters.length > 0) {
              this.ResetGroupsAndParameters();
              this.reportForm.patchValue({...report});

              response.Parameters.forEach((x) => {
                switch (x.GridCol) {
                  case 0:
                    this.parameterSubgroup1.push(x);
                    break;
                  case 1:
                    this.parameterSubgroup2.push(x);
                    break;
                  case 2:
                    this.parameterSubgroup3.push(x);
                    break;
                  case 3:
                    this.parameterSubgroup4.push(x);
                    break;
                }
              });
            }
          } else {
            this.alertService.ShowBigCenteredAlert(
              response.ErrorInfo.Message,
              ALERTS.error
            );
          }
        },
        (err) => {
          console.log(err);
          this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
        }
      );
  }

  async onClickSaveChanges() {
    const report = this.getReportModel();

    if (!report.Parameters || report.Parameters.length === 0) {
      const confirmResult = await this.alertService.ConfirmationAlert(
        'Confirmación',
        'No han agregado parámetros al reporte ¿Desea continuar?',
        'Continuar'
      );

      if (!confirmResult) return;
    }

    if (this.report !== null) {

      this.blockUI.Start(1, `Procesando, espere por favor`);

      this.rptManagerService.SaveReportFile(this.report, this.CompanyKeyParam, this.AppKeyParam)
        .pipe(finalize(() => this.blockUI.Stop())).subscribe(response => {
          if (response.Result) {
            report.ApplicationId = this.Application.Id;
            this.HandlePostOrPutReport(report);
          } else {
            this.alertService.ShowBigCenteredAlert(response.ErrorInfo.Message, ALERTS.error);
          }
        }, err => {
          console.log(err);
          this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
        }
        );
    } else {
      report.ApplicationId = this.Application.Id;
      this.HandlePostOrPutReport(report);
    }
  }

  async onClickDeleteParam(paramList: ReportParameter2[], index: number) {
    let confirmResult = await this.alertService.ConfirmationAlert(
      'Confirmación',
      '¿Desea eliminar el parámetro?',
      'Continuar'
    );
    if (confirmResult) paramList.splice(index, 1);
  }

  onClickAddParameter() {
    let parameter = this.getParameterFromForm();
    this.parameterSubgroup1.push(parameter);
    this.resetParameterForm();
    this.resetParameterValueForm();
    this.parameterOptions = null;
  }

  onClickPrintReport(longContent: any, _reportId?: number) {
    this.reportId = _reportId;
    this.modalService.open(longContent, {
      size: 'xl',
      scrollable: true,
      centered: true,
      windowClass: "dark-modal",
    });
  }

  onClickDownloadFile() {
    if (!this.reportForm.get('Id').value) return;
    this.blockUI.Start(1, `Procesando espere por favor`);
    this.rptManagerService
      .DownloadFile(Number(this.reportForm.get('Id').value)).pipe(finalize(() => this.blockUI.Stop()))
      .subscribe((response) => {
        if (response.Result) {
          this.commonService.downloadFile(
            response.Print,
            this.reportForm.get('DisplayName').value,
            'application/octet-stream',
            'rpt'
          );
        } else {
          this.alertService.ShowBigCenteredAlert(
            response.ErrorInfo.Message,
            ALERTS.error
          );
        }
      }, error => {
        console.info(error);
      });
  }

  get reportFormControls() {
    return this.reportForm.controls;
  }

  get parameterFormControls() {
    return this.parameterForm.controls;
  }

  getReportModel() {
    this.parameters = [];
    this.paramaterListGroup.forEach((list, col) => {
      list.forEach((param, row) => {
        param.GridCol = col;
        param.GridRow = row;
        this.parameters.push(param);
      });
    });

    const report: Report2 = {
      Actve: true,
      ApplicationId: 0,
      ReportUserId: Number(this.reportForm.get('ReportUserId').value),
      DisplayName: this.reportForm.get('DisplayName').value,
      Name: this.reportForm.get('Name').value,
      Id: this.reportForm.get('Id').value,
      Parameters: this.parameters,
      DBCode: this.reportForm.get('DBCode').value,
      SAPConnection: this.reportForm.get('SAPConnection').value
    };

    return report;
  }

  onReportSelected($event) {
    this.report = <File>$event.target.files[0];

    if (!this.report) return;
    if (!this.commonService.isValidFile(this.report, ['rpt'])) {
      this.report = null;
      this.alertService.ShowBigCenteredAlert(
        'Archivo no soportado',
        ALERTS.warning
      );
      return;
    }

    this.reportForm.get('Name').setValue(this.report.name);
  }

  getParameterFromForm() {
    let parameter: ReportParameter2 = {
      Id: Number(this.parameterForm.get('Id').value),
      Name: this.parameterForm.get('Name').value,
      DisplayName: this.parameterForm.get('DisplayName').value,
      ReportId: Number(this.reportForm.get('Id').value),
      Type: Number(this.parameterForm.get('Type').value),
      GridCol: 0,
      GridRow: 0,
      Options: this.parameterOptions,
      Required: this.parameterForm.get('Required').value === 'S',
      DataSourceConfiguration: this.GetParameterDataSource(),
      PreloadedSource: [],
      MappedPrealoadSource: []
    };

    return parameter;
  }

  getParameterType(type) {
    switch (type) {
      case REPORT_PARAMETER.Alpha:
        return 'Alfanumérico';
      case REPORT_PARAMETER.Boolean:
        return 'Check';
      case REPORT_PARAMETER.Date:
        return 'Fecha';
      case REPORT_PARAMETER.Numeric:
        return 'Numérico';
      case REPORT_PARAMETER.MultipleOption:
        return 'Opción múltiple';
      default:
        return '';
    }
  }

  onItemDropped(event) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  dismissModal(result: boolean) {
    this.modalService.dismissAll(result);
  }

  onTabChange() {
    if (this.activeTab === 1) {
      this.initializeApp();
    }
  }

  showParameterOptionsModal(
    modalParameterOptions: any,
    options: ParameterOption[]
  ) {
    this.parameterOptionsModal = options;
    let modal = this.modalService.open(modalParameterOptions, {
      size: 'lg',
      backdrop: true,
      scrollable: true,
    });

    modal.result.then(
      () => { },
      () => {
        options = this.parameterOptionsModal;
        this.parameterOptionsModal = null;
      }
    );
  }

  onParameterTypeChange(event: any, modalParameterOptions: any) {
    if (Number(event.target.value) === REPORT_PARAMETER.MultipleOption) {
      if (!this.parameterOptions) this.parameterOptions = [];

      this.showParameterOptionsModal(
        modalParameterOptions,
        this.parameterOptions
      );
    }
  }

  onClickParameterOptions(
    parameter: ReportParameter2,
    modalParameterOptions: any
  ) {
    this.showParameterOptionsModal(modalParameterOptions, parameter.Options);
  }

  onClickAddParameterValidValue() {
    this.parameterOptionsModal.push({
      ...this.parameterValueForm.value,
      Id: 0,
      ParameterId: 0,
    });
    this.resetParameterValueForm();
  }

  onClickDeleteValidValue(index: number) {
    if (this.parameterOptionsModal.length === 1) {
      this.alertService.ShowSmallCornerAlert(
        'Debes agregar al menos una opción válida',
        ALERTS.info
      );
      return;
    }

    this.parameterOptionsModal.splice(index, 1);
  }

  DismissAppModal(): void {
    this.modalReference.close();
  }

  GoToHome(): void {
    this.DismissAppModal();
    if (!this.isRaisedFromEvent) {
      this.menu.forEach(x => {
        x.Selected = false;
        if (x.Children.length > 0) {
          x.Children.forEach(y => y.Selected = false);
        }
      });
      this.menu.find(x => x.Name === 'Inicio').Selected = true;
      this.sidebarService.currentPath.next('Inicio');
      this.alertService.ShowSmallCornerAlert(`Sin seleccionar la aplicación no se puede acceder a esta configuración`, ALERTS.info);
      this.router.navigateByUrl('/home');
    }
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      merge(this.focus$),
      merge(this.click$),
      map(term => (term === '' ? this.Companies.map(x => x.Name)
        : this.Companies.map(x => x.Name).filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
    );

  SelectApp(appID: number): void {
    this.applications.forEach(x => x.UIsSelected = false);
    this.applications.find(x => x.Id === appID).UIsSelected = true;
  }

  SetApplication(): void {
    this.Application = this.applications.find(x => x.UIsSelected);

    if (!this.Application) {
      this.alertService.ShowSmallCornerAlert(`Seleccione una aplicación por favor`, ALERTS.info);
      return;
    }

    this.DismissAppModal();

    if (this.Application && this.Company) {

      this.commonService.appOrCompanyHeaderTittle.next({ ObjecName: this.Company.Name + ', ' + this.Application.Name, From: 2 });
      this.getReports();
    } else {
      this.alertService.ShowSmallCornerAlert(`A ocurrido un error, intente refrescando la pagina.`, ALERTS.info);
    }

  }

  RiseSelectAppModal(modalContent: any): void {

    this.modalReference = this.modalService.open(modalContent, {
      centered: true,
      backdrop: 'static'
    });
  }

  RaisedFromEvent(): void {
    this.isRaisedFromEvent = true;
    this.GetCompanies();
  }

  GetCompanies(): void {
    this.blockUI.Start(1, `Procesando, espere por favor`);
    this.companyService.GetCompanies().pipe(finalize(() => this.blockUI.Stop())).subscribe((next) => {
      if (next?.Result && next.Data.length > 0) {
        this.Companies = next.Data.filter((x) => x.Active);
      }
    }, (error) => {
      this.alertService.errorAlert(AppConstants.GetError(error));
    });
  }

  GetApplications(): void {
    this.blockUI.Start(1, `Procesando, espere por favor`);
    this.companyService.GetCompanyApplications(this.CompanyKeyParam).pipe(finalize(() => this.blockUI.Stop())).subscribe(next => {
      if (next?.Result) {
        this.applications = next.Data;
        this.Application = this.applications.find(y => y.Id === this.AppKeyParam);
      }
    }, error => {
      this.alertService.errorAlert(AppConstants.GetError(error));
    });
  }

  clickEvents($event, typeaheadInstance) {
    if (typeaheadInstance.isPopupOpen()) {
      this.click$.next($event.target.value);
    }
  }

  OnSelectCompany($event): void {
    let searchTerm = $event.item;
    let comp = this.Companies.find(x => x.Name === searchTerm);

    if (comp) {
      this.Company = comp;
      this.GetApplications();
    }
  }

  async onClickRemoveReport(report: Report): Promise<void> {

    const PERMS = this.storageService.GetPermissions().find(x => x.Code == 'V_Rpts_Delete');

    if (!PERMS) {
      this.alertService.ShowBigCenteredAlert('No cuenta con los permisos para realizar esta acción', 4);
      return;
    }

    const RESULT = await this.alertService.ConfirmationAlert('Se eliminará el reporte', '¿Desea continuar con la acción?', 'Continar');
    if (!RESULT) return;

    this.blockUI.Start(1, 'Procesando, espere por favor');

    this.rptManagerService.DeleteReport(report.Id).pipe(finalize(() => this.blockUI.Stop())).subscribe(result => {
      if (result?.Result) {
        this.alertService.successAlert('Operación terminada');
        this.getReports();
      }
    }, err => {
      console.log(err);
      this.alertService.errorAlert(AppConstants.GetError(err));
    });

  }

  GetParameterDataSource(): string {
    try {
      const PARAMETER_DATA_SOURCE: IParameterDataSource = {
        DBObjectName: this.parameterForm.get('DBObjectName')?.value,
        DBObjectType: "V",
        DBCode: this.reportForm.get('DBCode')?.value
      };

      return JSON.stringify(PARAMETER_DATA_SOURCE) ?? '{}';
    }
    catch (error) {
      return '{}';
    }
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    switch (changeEvent.nextId) {
      case 1:
        this.initializeApp();

        this.ReloadObjects();
        break;
      case 3:
        this.blockUI.Start(1, `Procesando, espere por favor`);

        changeEvent.preventDefault();
        this.ResetFormsOnClear();
        setTimeout(_ => this.blockUI.Stop(), 700);
        break;
      case 4:
        changeEvent.preventDefault();
        if (this.reportForm.invalid) {
          this.alertService.ShowSmallCornerAlert(`Nombre del reporte, archivo del reporte y usuario requeridos`, ALERTS.info);
        }
        else {
          this.onClickSaveChanges();
        }
        break;
      default:
        this.activeTab = changeEvent.nextId;
        break;
    }
  }
  disabled: boolean;

  toggleDisabled() {
    this.disabled = !this.disabled;
    if (this.disabled) {
      //this.active = 1;
    }
  }

  GetDataSource(_parameter: ReportParameter2): string {
    try {
      return JSON.parse(_parameter.DataSourceConfiguration)?.DBObjectName
    }
    catch (error) {
      return null;
    }
  }

  In(_value, ...values): boolean {
    try {
      let expression = `/^(${values.join('|')})$/`;
      return _value?.toString().match(expression, 'i');
    }
    catch (error) {
      console.log(error)
      return false;
    }
  }

  ResetGroupsAndParameters(): void {
    this.parameterSubgroup1 = [];
    this.parameterSubgroup2 = [];
    this.parameterSubgroup3 = [];
    this.parameterSubgroup4 = [];
    this.paramaterListGroup = [];
    this.parameters = [];
    this.paramaterListGroup.push(
      this.parameterSubgroup1,
      this.parameterSubgroup2,
      this.parameterSubgroup3,
      this.parameterSubgroup4
    );
    this.parameterOptions = [];
    this.parameterOptionsModal = [];
    this.resetParameterForm();
    this.resetReportForm();
    this.resetParameterValueForm();
  }

  ClearAllForms(): void {
    this.reportForm = this.formBuilder.group({
      Id: 0,
      Name: ['', Validators.required],
      DisplayName: ['', Validators.required],
      ReportUserId: [0, Validators.required],
      DBCode: [''],
      Server: ['']
    });

    this.parameterForm = this.formBuilder.group({
      Id: [0],
      ReportId: [0],
      Name: ['', Validators.required],
      DisplayName: ['', Validators.required],
      Type: [1, Validators.required],
      Required: ['S', Validators.required],
      DBObjectName: ['']
    });

    this.parameterValueForm = this.formBuilder.group({
      Key: ['', Validators.required],
      Value: ['', Validators.required],
    });
  }

  ReloadObjects(): void {

    this.GetCompanies();

    this.GetApplications();

    this.getReportUsers();

    this.getReports();

    this.GetConnections();
  }

  GetConnections(): void {
    try{
      this.blockUI.Start(1, `Procesando, espere por favor`);
      this.connectionService.GetConnections().pipe(finalize(() => this.blockUI.Stop())).subscribe(next => {
        try{
          if (next?.Result) {
            this.connections = next.Data.filter(conn => conn.Status);
          } else {
            this.alertService.ShowBigCenteredAlert(AppConstants.GetError(next.ErrorInfo), ALERTS.error);
          }
        } catch(exception){
          console.log(exception);
        }
      }, error => {
        this.alertService.errorAlert(AppConstants.GetError(error));
      });
    } catch(exception){
      this.blockUI.Stop();
      console.log(exception);
    } 
  }

}
